import {
  put,
  takeLatest,
  takeEvery,
  select,
  all,
  putResolve,
  take,
} from 'redux-saga/effects';
import _ from 'lodash';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  fixtureMatchSchema,
  fixtureMatchListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import {
  sagaActions,
  getAllPaymentEvents,
} from 'app/ducks/paymentEvents/actions';
import { getAllTeams } from 'app/ducks/teams/actions';
import { getAllGroups } from 'app/ducks/groups/actions';
import { TeamsActionTypes } from 'app/ducks/teams/types';
import { GroupsActionTypes } from 'app/ducks/groups/types';

import { PaymentEventsActionTypes as types } from 'app/ducks/paymentEvents/types';

function* createPaymentEventSaga(action): any {
  yield put(sagaActions.createPaymentEventPending(action.payload));
  const [error, response] = yield (yield (yield TeammoApi(yield select()))).fixtureMatches.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, fixtureMatchSchema);

    yield put(sagaActions.createPaymentEventSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createPaymentEventFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updatePaymentEventSaga(action): any {
  yield put(sagaActions.updatePaymentEventPending(action.payload));
  const [error, response] = yield (yield (yield TeammoApi(yield select()))).fixtureMatches.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, fixtureMatchSchema);

    yield put(sagaActions.updatePaymentEventSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updatePaymentEventFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* getPaymentEventSaga(action): any {
  yield put(sagaActions.getPaymentEventPending());
  const [error, response] = yield (yield (yield TeammoApi(yield select()))).fixtureMatches.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, fixtureMatchSchema);
    yield put(sagaActions.getPaymentEventSuccess(normalizedResponse));
    return normalizedResponse.entities.fixtureMatches[normalizedResponse.result];
  }
  yield put(
    handleError(
      error,
      sagaActions.getPaymentEventFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    ),
  );
  return null;
}

function* getAllPaymentEventsSaga(action): any {
  yield put(
    sagaActions.getAllPaymentEventsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.paymentEvents.pagination),
    )
    : action.payload.pagination;

  const [error, response] = yield (
    yield TeammoApi(yield select(), action.payload.organisationIds)
  ).fixtureMatches.list(paginationObject);

  if (response) {
    const normalizedResponse = normalize(response, fixtureMatchListSchema);

    yield put(
      sagaActions.getAllPaymentEventsSuccess(
        normalizedResponse,
        response.meta,
        action.payload.append,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllPaymentEventsFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    );
  }
}
function* getAllPaymentEventsForAllTeamsSaga(action): any {
  yield put(
    sagaActions.getAllPaymentEventsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.paymentEvents.pagination),
    )
    : action.payload.pagination;
  yield putResolve(getAllTeams());
  yield take(TeamsActionTypes.GET_ALL_TEAMS_SUCCESS);
  const teamsById = yield (yield select((state) => state.teams.teamsById));
  // const groupIds = _.map(_.filter(
  //   teamsById,
  //   (team) => {
  //     if (!_.isEmpty(team.group?.id)) {
  //       return team.group?.id;
  //     }
  //   },
  // ), (team) => team.group?.id);

  let groupIds = [];
  let orgIds = [];

  _.each(teamsById, (t) => {
    _.each(t.groups, (g) => {
      if (!_.isEmpty(g?.id)) {
        groupIds.push(g.id);
      }
    });
  });

  _.each(teamsById, (t) => {
    _.each(t.organisations, (o) => {
      if (!_.isEmpty(o?.id)) {
        orgIds.push(o.id);
      }
    });
  });

  groupIds = _.uniq(groupIds);
  orgIds = _.uniq(orgIds);

  // let orgIds = _.map(_.filter(teamsById, (team) => {
  //   if (!_.isEmpty(team.organisation?.id)) {
  //     return team.organisation?.id;
  //   }
  // }), (team) => team.organisation?.id);
  // console.log(groupIds);
  // console.log(orgIds);
  // if (_.isEmpty(groupIds) || _.isEmpty(orgIds)) {
  //   yield put(GroupsActionTypes.GET_ALL_GROUPS_SUCCESS);
  //   yield put(types.GET_ALL_PAYMENT_EVENTS_SUCCESS);
  //   yield put(loadingFinish());
  //   return;
  // }
  yield putResolve(
    getAllGroups(
      undefined,
      {
        filter: {
          ...paginationObject.filter,
          id: _.uniq(groupIds).join(','),
        },
        sort: '-match-at',
        page: {
          size: 200,
        },
      },
      false,
      _.uniq(orgIds).join(','),
    ),
  );
  yield take([
    GroupsActionTypes.GET_ALL_GROUPS_SUCCESS,
    GroupsActionTypes.GET_ALL_GROUPS_FAIL,
  ]);
  const groupsById = yield (yield select((state) => state.groups.groupsById));
  orgIds = _.map(groupsById, (group) => group.organisation?.id);
  const composedFilter = {
    filter: {
      ...paginationObject.filter,
      'group-id': _.uniq(groupIds).join(','),
    },
    sort: `${paginationObject.sort},-match-at`,
    page: {
      size: 200,
    },
  };
  // console.log(composedFilter);
  yield putResolve(
    getAllPaymentEvents(composedFilter, false, _.uniq(orgIds).join(',')),
  );
  yield take(types.GET_ALL_PAYMENT_EVENTS_SUCCESS);
  yield put(loadingFinish());
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createPaymentEventSagaWatcher(): any {
  yield takeEvery(
    types.CREATE_PAYMENT_EVENT_REQUESTED,
    createPaymentEventSaga,
  );
}

function* updatePaymentEventSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_PAYMENT_EVENT_REQUESTED,
    updatePaymentEventSaga,
  );
}

function* getPaymentEventSagaWatcher(): any {
  yield takeLatest(
    types.GET_PAYMENT_EVENT_REQUESTED,
    getPaymentEventSaga,
  );
}

function* getAllPaymentEventsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_PAYMENT_EVENTS_REQUESTED,
    getAllPaymentEventsSaga,
  );
}
function* getAllPaymentEventsForAllTeamsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_PAYMENT_EVENTS_FOR_ALL_TEAMS_REQUESTED,
    getAllPaymentEventsForAllTeamsSaga,
  );
}

export default function* root(): any {
  yield all([
    createPaymentEventSagaWatcher(),
    updatePaymentEventSagaWatcher(),
    getPaymentEventSagaWatcher(),
    getAllPaymentEventsSagaWatcher(),
    getAllPaymentEventsForAllTeamsSagaWatcher(),
  ]);
}
